<template>
  <div>
    <h1>404 Not Found Page</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFoundComponent'
}
</script>

<style scoped>
h1 {
  text-align: center;
}

div {
  padding-top: 100px;
}
</style>
